import React from 'react';
import useDarkMode from 'use-dark-mode';

import CloseButton, {
  Variant as CloseVariant
} from '@swf/components/StarsModal/components/CloseButton';
import ModalHeader, {
  Variant as HeaderVariant
} from '@swf/components/StarsModal/components/Header/Header';

import styles from './Header.scss';

interface Props {
  title: React.ReactNode;
}

const Header: React.FC<Props> = ({ title = null }) => {
  const { value: isDarkMode } = useDarkMode();

  return (
    <ModalHeader
      className={styles.header}
      variant={isDarkMode ? HeaderVariant.Dark : HeaderVariant.Light}
    >
      {title}
      <CloseButton variant={isDarkMode ? CloseVariant.Light : CloseVariant.Dark} />
    </ModalHeader>
  );
};

export default Header;
